import React, {FC} from 'react'
import {publicDocumentUrl} from '../PublicModels'

type Props = {
  headerDocumentId?: string | null
  compact?: boolean
}

/** Firmanın üst görseli; yüklenmemişse koyu degrade gösterilir */
export const PublicBanner: FC<Props> = ({headerDocumentId, compact = false}) => {
  const imageUrl = publicDocumentUrl(headerDocumentId)
  return (
    <div className={`pc-banner ${compact ? 'pc-banner--compact' : ''}`}>
      {imageUrl && <img src={imageUrl} alt='' />}
    </div>
  )
}
